import { Spacer, TextInput } from '@jfs/ui-new'
import { ChangeEmailId } from '../../comps/ChangeEmaiId'
import { OtpTextInput } from '../../comps/OtpTextInput'
import RememberMe from '../../screens/Login/LoginCard/RememberMe'
import { email, mobileNumber, otp, password } from '../../util/validations'

export const loginForm = (
  entererdMobileNumber: string,
  getEyeRightView: any,
  showPassword: boolean,
  isLoading: boolean,
  onChecked: any,
  isChecked: boolean,
): any => [
  {
    actionTitle: 'Login',
    formItems: [
      {
        fieldName: 'mobileNumber',
        ComponentName: TextInput,
        // type: TextInputType.LOGIN_MOBILE, //TODO: handle this as per design in TextInput
        testID: 't-mobile',
        accessibilityLabel: 't-mobile',
        validationSchema: mobileNumber,
        maxLength: 10,
        inputMode: 'numeric',
        onFocusBottomLineColor: 'BLUE',
        autoFocus: true,
        label: 'Registered phone number (10 digits)',
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 1,
      },
      {
        fieldName: 'password',
        ComponentName: TextInput,
        testID: 't-password',
        accessibilityLabel: 't-password',
        label: 'Password',
        validationSchema: password,
        hideText: showPassword ? false : true,
        rightComponent: getEyeRightView,
        displayName: 'Password',
        onFocusBottomLineColor: 'BLUE',
        secureTextEntry: showPassword ? false : true,
        returnKeyType: 'done',
      },
      {
        fieldName: 'remMeForgotPwdView',
        ComponentName: RememberMe,
        enteredMobile: entererdMobileNumber,
        btnLoading: isLoading,
        onChecked: onChecked,
        isChecked: isChecked,
      },
      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

export const getEmailLoginFormData = ({ onChangeEmailIdPress }) => [
  {
    key: 'mobile',
    formItems: [
      {
        fieldName: 'email',
        ComponentName: TextInput,
        validationSchema: email,
        maxLength: 50,
        onFocusBottomLineColor: 'BLUE',
        autoFocus: true,
        label: 'Registered Email Id',
        fontFamily: 'jioType-medium',
        fontWeight: 500,
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 8,
      },
    ],
    actionTitle: 'Send Otp',
  },
  {
    key: 'password',
    actionTitle: 'Login',
    formItems: [
      {
        fieldName: 'changeEmailId',
        ComponentName: ChangeEmailId,
        onPress: onChangeEmailIdPress,
        textColor: 'BLUE',
      },
      {
        fieldName: 'spacer1',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 14,
      },
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        inputType: 'bottomline',
        validationSchema: otp,
        label: 'Enter Otp',
        returnKeyType: 'done',
        fontSize: 16,
        labelFontSize: 14,
        lineHeight: 24,
        selectionColor: 'BLUE',
      },
      {
        fieldName: 'spacer2',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 14,
      },
    ],
  },
]

/*
const allowedDomains = ['@ril.com']
export const emailValidation = Yup.string()
  .email('Invalid email format')
  .test('is-valid-domain', 'Invalid Email Id', (value) => {
    if (!value) {
      return false
    }
    return allowedDomains.some((domain) => value.endsWith(domain))
  })*/
